import React from 'react'
import TemplatesPageLayout from 'container/TemplatesPageLayout'

const Templates: React.FC = () => {
	return <TemplatesPageLayout />
}

export default Templates
